import { pathToRegexp } from "path-to-regexp";
import { useRouteMatch as useRouteMatchReact } from "react-router-dom";
export function pathMatchesRoute(pathOrLocation, route) {
    const pathname = typeof pathOrLocation === "string"
        ? pathOrLocation
        : pathOrLocation.pathname;
    if (!pathname) {
        return false;
    }
    return pathToRegexp(route).test(pathname);
}
export const useRouteMatch = () => {
    return useRouteMatchReact();
};
